import React, { useEffect, useState } from 'react';

const COOLDOWN_DURATION = 60_000; // 1 минута в мс

export const EmailCooldownTimer = () => {
  const [timeLeftMs, setTimeLeftMs] = useState(0);

  useEffect(() => {
    const lastSent = Number(localStorage.getItem('email_confirm_last_sent_at'));
    const now = Date.now();

    if (lastSent && now - lastSent < COOLDOWN_DURATION) {
      const remaining = COOLDOWN_DURATION - (now - lastSent);
      setTimeLeftMs(remaining);

      const interval = setInterval(() => {
        setTimeLeftMs((prev) => {
          const newTimeLeft = prev - 1000;
          return newTimeLeft > 0 ? newTimeLeft : 0;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, []);

  const formatTime = (ms: number) => {
    const totalSeconds = Math.ceil(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  if (timeLeftMs <= 0) return null;

  return <span style={{ color: 'rgba(49, 83, 115, 1)' }}>{formatTime(timeLeftMs)}</span>;
};
